import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState } from 'react';
import { getCreateGroupChannel } from './sendbirdSelectors.js';
import useSendbirdStateContext from './useSendbirdStateContext.js';
var CHANNEL_TYPE = /*#__PURE__*/function (CHANNEL_TYPE) {
  CHANNEL_TYPE["GROUP"] = "group";
  CHANNEL_TYPE["SUPERGROUP"] = "supergroup";
  CHANNEL_TYPE["BROADCAST"] = "broadcast";
  return CHANNEL_TYPE;
}({});
var CreateChannelContext = /*#__PURE__*/React__default.createContext(undefined);
var CreateChannelProvider = function CreateChannelProvider(props) {
  var _store$config;
  var children = props.children,
    onCreateChannel = props.onCreateChannel,
    onBeforeCreateChannel = props.onBeforeCreateChannel,
    overrideInviteUser = props.overrideInviteUser,
    userListQuery = props.userListQuery;
  var store = useSendbirdStateContext();
  var userListQuery_ = store === null || store === void 0 ? void 0 : (_store$config = store.config) === null || _store$config === void 0 ? void 0 : _store$config.userListQuery;
  var createChannel = getCreateGroupChannel(store);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useState3 = useState(CHANNEL_TYPE.GROUP),
    _useState4 = _slicedToArray(_useState3, 2),
    type = _useState4[0],
    setType = _useState4[1];
  return /*#__PURE__*/React__default.createElement(CreateChannelContext.Provider, {
    value: {
      onBeforeCreateChannel: onBeforeCreateChannel,
      createChannel: createChannel,
      onCreateChannel: onCreateChannel,
      overrideInviteUser: overrideInviteUser,
      userListQuery: userListQuery || userListQuery_,
      step: step,
      setStep: setStep,
      type: type,
      setType: setType
    }
  }, children);
};
var useCreateChannelContext = function useCreateChannelContext() {
  return React__default.useContext(CreateChannelContext);
};
export { CreateChannelProvider as C, CHANNEL_TYPE as a, useCreateChannelContext as u };